/** A renter's own conversation, /chat/<token> (MTR #223). In its own file so a server can read the shape. */
export const chatTokenFromPath = (path) => {
  const m = /^\/chat\/([A-Za-z0-9_-]{43})\/?$/.exec(String(path ?? ''))
  return m ? m[1] : null
}
